







































import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  NavBar,
  Image,
  Tabbar,
  TabbarItem,
  Search,
  Field,
  Picker,
  Popup,
  Button,
  Toast,
  List,
  Cell,
  CellGroup,
  Dialog,
  Tag,
  Icon,
  Row,
  Col,
  NoticeBar,
  Loading,
  Card,
  Form,
} from "vant";
import WeMixin from "@/components/weMixin";
import api from "../../../components/http/api";
import { BdhdSignInfo } from "./BdhdSignApi";

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Card.name]: Card,
    [Search.name]: Search,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [NoticeBar.name]: NoticeBar,
    [Loading.name]: Loading,
    [Form.name]: Form,
  },
})
export default class BdhdSign extends mixins(WeMixin) {
  private info: BdhdSignInfo = {} as BdhdSignInfo;
  private show: boolean = true;
  private showResult: boolean = false;
  private msg: string = "";

  private buttonActive: boolean = false;

  private isError: boolean = true;
  private isShowError: boolean = false;

  protected created() {
    this.info.orgid = this.$route.params.orgid;
    this.info.userid = this.$route.params.userid;
    api.post("/weixinmp/xsyx/myuser/checkIsSubscribe", {}).then((res: any) => {
      if (!res.data) {
        this.$router.push("/main/sign/bdhdUnregistered");
      } else {
        api.get("/weixinmp/xsyx/myuser/getCustomerInfo").then((res1: any) => {
          console.log(res1.data);
          if (res1.data.flag === "0") {
            api
              .post("/weixinmp/xsyx/sign/bdhdSign", this.info)
              .then((res2: any) => {
                this.show = false;
                this.showResult = true;
                this.msg = res2.data.msg;
                setTimeout(() => {
                  if (res2.data.flag) {
                    window.location.href =
                      "https://wap.psbc.com/mobilebank/skipCellPhoneAPPToActivityPage.do?activityId=208672620404736&source=0&pageId=1145";
                  }
                }, 1000);
              });
          } else if (res1.data.flag === "1") {
            this.$router.push(
              "/main/user/registerFromBdhd/" +
                this.$route.params.orgid +
                "&" +
                this.$route.params.userid.replace(/\//g, "%2F")
            );
          }
        });
      }
    });
  }
}
